import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ObjectivesData {
  items = [
    {
      name: 'Remembering',
      description: 'Recall concepts related to the topic.',
      terms: [
        'define',
        'identify',
        'label',
        'list',
        'match',
        'name',
        'outline',
        'quote',
        'recall',
        'recite',
        'recognize',
      ],
    },
    {
      name: 'Understanding',
      description: 'Describe or explain ideas related to the topic.',
      terms: [
        'describe',
        'explain',
        'paraphrase',
        'restate',
        'give original examples of',
        'summarize',
        'contrast',
        'interpret',
        'discuss',
      ],
    },
    {
      name: 'Applying',
      description:
        'Use information related to the topic in a different situation.',
      terms: [
        'contrast',
        'describe',
        'discuss',
        'explain',
        'give original examples of',
        'interpret',
        'paraphrase',
        'restate',
        'summarize',
      ],
    },
    {
      name: 'Analyzing',
      description:
        'Link or draw connections between ideas related to the topic.',
      terms: [
        'analyze',
        'associate',
        'break down',
        'categorize',
        'classify',
        'criticize',
        'diagram',
        'illustrate',
        'simplify',
      ],
    },
    {
      name: 'Evaluating',
      description: 'Justify, argue or critique a point related to the topic.',
      terms: [
        'argue',
        'choose',
        'compare',
        'contrast',
        'convince',
        'defend',
        'determine',
        'evaluate',
        'grade',
        'judge',
        'justify',
        'relate',
        'select',
        'support',
      ],
    },
    {
      name: 'Creating',
      description: 'Create new or original work related to the topic.',
      terms: [
        'build',
        'compose',
        'conduct',
        'create',
        'derive',
        'design',
        'develop',
        'formulate',
        'generate',
        'invent',
        'modify',
      ],
    },
  ];

  constructor() {}
  /**
   * Get Objective data array
   * @param caps Should first leter be capitialized
   */
  getItems(caps?: boolean): Observable<any[]> {
    if (caps) {
      return of(
        this.items.map(i => {
          i.terms = i.terms.map(t => this.toCaps(t));
          return i;
        })
      );
    }
    return of(this.items);
  }

  /**
   * Capitalize the first leter in a word
   * @param word word to capitalize
   */
  toCaps(word: string): string {
    return word.charAt(0).toUpperCase() + word.slice(1);
  }
}
